import { ContryId, DefaultId } from "./Globals"

export type Default = string

type Content = string
export type PropertyBagProps = { accountIndex: number } & { [kycFieldId: string]: Content }
export type PropertyBagData = { [kycFieldId: string]: FieldWithStatus }

export type FieldWithStatus = {
    content: Content;
    approved: boolean;
}

export enum FieldTypes {
    TextField = "Text-Field",
    PasswordField = "Password-Field",
    EmailField = "Email-Field",
    FileField = "File-Field",
    AddressField = "Address-Field",
    PhoneField = "Phone-Field",
    Select = "Select",
    CountrySelect = "Country-Select",
    BankAccount = "Bank-Account"
}

export type Option = {
    name: string,
    value: string
}

export type Property = {
    property: string;
    propertyDescription?: string;
    type: FieldTypes;
    required: boolean;
    options?: Option[]
}

export type PropertyBag = {
    proptertyBagId: ContryId | Default;
    properties: Property[];
}

export type KYCPolicyProps = {
    company?: boolean
}


export const defaultPrivatePolicy: PropertyBag = {
    proptertyBagId: DefaultId,
    properties: [
        {
            property: "ADDRESS",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "ZIP_AND_CITY",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "BANK_ACCOUNT",
            propertyDescription: "BANK_ACCOUNT_DESCRIPTION",
            required: true,
            type: FieldTypes.BankAccount
        },
        {
            property: "SOCIAL_SECURITY_NUMBER",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "PASSPORT",
            required: true,
            type: FieldTypes.FileField
        },
        {
            property: "IDENTIFICATION",
            propertyDescription: "IDENTIFICATION_DESCRIPTION",
            required: true,
            type: FieldTypes.FileField
        },
        {
            options: [
                {
                    name: "SALARY_PENSION",
                    value: "salary-pension"
                },
                {
                    name: "SAVINGS",
                    value: "savings"
                },
                {
                    name: "HERITAGE_GIFT",
                    value: "heritage-gift"
                },
                {
                    name: "LOTTERY",
                    value: "lottery-games"
                },
                {
                    name: "INTREST_REVENUE",
                    value: "intrest-revenue"
                },
                {
                    name: "OTHER",
                    value: "other"
                }
            ],
            property: "CAPITAL_SOURCE_DESCRIPTION",
            required: true,
            type: FieldTypes.Select
        },
        {
            options: [
                {
                    name: "OPTIMIZE_CAPITAL_OR_PENSION",
                    value: "optimize-capital-or-pension"
                },
                {
                    name: "AS_GIFT_TO_RELATIVE",
                    value: "as-gift-to-relative"
                },
                {
                    name: "ALTERNATIVE_TO_DONATIONS",
                    value: "alternative-to-donations"
                },
                {
                    name: "TRADING",
                    value: "trading"
                },
                {
                    name: "OTHER",
                    value: "other"
                }
            ],
            property: "WHY_WILL_YOU_RENT_OUT_CAPITAL",
            required: true,
            type: FieldTypes.Select
        },
        {
            options: [
                {
                    name: "_LESS_THAN_100_000_DKK",
                    value: "less-than-100.000-dkk"
                },
                {
                    name: "_100_000_TO_750_000_DKK",
                    value: "100.000-TO-750.000-DKK"
                },
                {
                    name: "_750_000_TO_2_000_000_DKK",
                    value: "750.000-DKK-TO-2.00.000-DKK"
                },
                {
                    name: "_MORE_THAN_2_000_000_DKK",
                    value: "more-than-2.000.000-DKK"
                }
            ],
            property: "HOW_MUCH_DO_YOU_PLAN_ON_LENDING_OUT",
            required: true,
            type: FieldTypes.Select
        },
        {
            options: [
                {
                    name: "YES",
                    value: "YES"
                },
                {
                    name: "NO",
                    value: "NO"
                }
            ],
            property: "PEP_LIST_MEMBER",
            required: true,
            type: FieldTypes.Select
        }
    ]
}

export const defaultCompanyPolicy: PropertyBag = {
    proptertyBagId: DefaultId,
    properties: [
        {
            property: "CVR_OR_COMANY_REGISTRATION",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "ADDRESS",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "ZIP_AND_CITY",
            required: true,
            type: FieldTypes.TextField
        },
        {
            property: "BANK_ACCOUNT",
            propertyDescription: "BANK_ACCOUNT_DESCRIPTION",
            required: true,
            type: FieldTypes.BankAccount
        },
        {
            property: "COMPANY_PASSPORT",
            propertyDescription: "COMPANY_PASSPORT_DESCRIPTION",
            required: true,
            type: FieldTypes.FileField
        },
        {
            property: "COMPANY_IDENTIFICATION",
            propertyDescription: "COMPANY_IDENTIFICATION_DESCRIPTION",
            required: true,
            type: FieldTypes.FileField
        },
        {
            property: "REGISTER_OF_OWNERS",
            propertyDescription: "REGISTER_OF_OWNERS_DESCRIPTION",
            required: true,
            type: FieldTypes.FileField
        },
        {
            property: "INSTRUMENT_OF_INCORPORATION",
            propertyDescription: "INSTRUMENT_OF_INCORPORATION_DESCRIPTION",
            required: true,
            type: FieldTypes.FileField
        },
        {
            options: [
                {
                    name: "SALARY_PENSION",
                    value: "salary-pension"
                },
                {
                    name: "SAVINGS",
                    value: "savings"
                },
                {
                    name: "HERITAGE_GIFT",
                    value: "heritage-gift"
                },
                {
                    name: "LOTTERY",
                    value: "lottery-games"
                },
                {
                    name: "INTREST_REVENUE",
                    value: "intrest-revenue"
                },
                {
                    name: "OTHER",
                    value: "other"
                }
            ],
            property: "CAPITAL_SOURCE_DESCRIPTION",
            required: true,
            type: FieldTypes.Select
        },
        {
            options: [
                {
                    name: "OPTIMIZE_CAPITAL_OR_PENSION",
                    value: "optimize-capital-or-pension"
                },
                {
                    name: "AS_GIFT_TO_RELATIVE",
                    value: "as-gift-to-relative"
                },
                {
                    name: "ALTERNATIVE_TO_DONATIONS",
                    value: "alternative-to-donations"
                },
                {
                    name: "TRADING",
                    value: "trading"
                },
                {
                    name: "OTHER",
                    value: "other"
                }
            ],
            property: "WHY_WILL_YOU_RENT_OUT_CAPITAL",
            required: true,
            type: FieldTypes.Select
        },
        {
            options: [
                {
                    name: "_LESS_THAN_100_000_DKK",
                    value: "less-than-100.000-dkk"
                },
                {
                    name: "_100_000_TO_750_000_DKK",
                    value: "100.000-TO-750.000-DKK"
                },
                {
                    name: "_750_000_TO_2_000_000_DKK",
                    value: "750.000-DKK-TO-2.00.000-DKK"
                },
                {
                    name: "_MORE_THAN_2_000_000_DKK",
                    value: "more-than-2.000.000-DKK"
                }
            ],
            property: "HOW_MUCH_DO_YOU_PLAN_ON_LENDING_OUT",
            required: true,
            type: FieldTypes.Select
        }
    ]
}

